import React from 'react'
import {
  Typography,
  Collapse,
  Alert,
  AlertTitle,
  Switch,
  FormControlLabel,
} from '@the-platform-group/component-library'

const OverdueBanner = ({ overdue, overdueCount, handleOverdueChange }) => {
  return (
    <Collapse in={true} sx={{ py: 2 }}>
      <Alert
        sx={{ alignItems: 'center' }}
        severity="error"
        action={
          <FormControlLabel
            checked={overdue}
            value={overdue}
            control={<Switch color="primary" />}
            label="Show overdue requests"
            labelPlacement="end"
            onChange={e => handleOverdueChange(e.target.checked)}
          ></FormControlLabel>
        }
      >
        <AlertTitle>
          {overdueCount} requests have exceeded their expected completion date
        </AlertTitle>
        <Typography>
          Please update the status to "Completed" or adjust the expected completion date and notify
          the client about the delay.
        </Typography>
      </Alert>
    </Collapse>
  )
}

export default OverdueBanner
